export default "__VITE_ASSET__Cup7lCVE__"